import { apiRequest } from 'src/api';

import { transformVendor } from './redux/reducers';

export const getVendor = vendorId => {
  return apiRequest({
    url: `/api/v1/vendors/?id=${vendorId}`,
    method: 'GET',
    responseDataAdapter: response =>
      response[0] ? transformVendor(response[0]) : null,
  });
};

export const getVendorsByName = name => {
  return apiRequest({
    url: `/api/v1/vendors/?vendor_business_name=${name}&page=1&page_size=10`,
    method: 'GET',
    responseDataAdapter: response =>
      response.results.map(v => transformVendor(v)),
  });
};
